import {
  AllegroResponsibleProducer,
  AllegroResponsibleProducers,
} from './responsibleProducerTypes';

export const mockAllegroResponsibleProducer: AllegroResponsibleProducer = {
  id: '2a2dc574-2d4e-5d2f-b1d9-3d7f1e4b1f02',
  name: 'Producent odpovědný za baterie',
  producerData: {
    tradeName: 'Battery Maker s.r.o.',
    address: {
      countryCode: 'CZ',
      street: 'Václavské náměstí 1',
      postalCode: '11000',
      city: 'Praha',
    },
    contact: {
      email: 'producer@example.cz',
      phoneNumber: '+420601123457',
    },
  },
};

export const mockGetAllegroResponsibleProducers: AllegroResponsibleProducers = {
  responsibleProducers: [mockAllegroResponsibleProducer],
  count: 1,
  totalCount: 1,
};
